import React, { Component } from 'react'
import Container from '../../components/layout/container.component'
import Title from '../../components/typography/title.component'
import { StyledRegulation } from './benefits.styles'

class BenefitsPage extends Component {
	render() {
		const { history } = this.props

		return (
			<Container style={{ paddingBottom: '5rem' }}>
				<Title>
					<span className="bold">Benefícios e Gratuidades</span>
				</Title>
				<StyledRegulation>
					<div>
						<h3>
							<strong>Descontos e Gratuidades para Passageiros</strong>
						</h3>
						<p>
							Com base nas legislações vigentes, apresentamos um resumo
							dos benefícios de descontos e gratuidades disponíveis para
							idosos, portadores de ID Jovem e beneficiários do Passe
							Livre no transporte rodoviário interestadual de passageiros.
						</p>
						<ul>
							<li>
								<strong>Idosos</strong>
								<ul>
									<li>
										<strong>Gratuidade:</strong> Dois assentos
										gratuitos por ônibus para pessoas idosas com renda
										de até dois salários mínimos, conforme a Lei nº
										10.741/2003 (Estatuto do Idoso) e a Resolução nº
										6.033, de 21 de dezembro de 2023.
									</li>
									<li>
										<strong>Desconto:</strong> Quando esgotadas as
										vagas gratuitas, é garantido um desconto mínimo de
										50% no preço do serviço para idosos com renda de
										até dois salários mínimos, utilizando como
										referência o preço mais baixo praticado pela
										empresa transportadora.
									</li>
								</ul>
							</li>
							<li>
								<strong>ID Jovem</strong>
								<ul>
									<li>
										<strong>Gratuidade:</strong>
										Dois assentos gratuitos por ônibus para jovens de
										baixa renda, titulares da Identidade Jovem, de
										acordo com a Lei nº 12.852/2013 (Estatuto da
										Juventude) e a Resolução nº 6.033, de 21 de
										dezembro de 2023.
									</li>
									<li>
										<strong>Desconto:</strong> Quando esgotadas as
										vagas gratuitas, é garantido dois assentos com um
										desconto mínimo de 50% no preço do serviço,
										utilizando como referência o preço mais baixo
										praticado pela empresa transportadora.
									</li>
								</ul>
							</li>
							<li>
								<strong>Passe Livre</strong>
								<ul>
									<li>
										<strong>Gratuidade:</strong> Vagas gratuitas, sem
										limitação de assentos, para pessoas com
										deficiência, comprovadamente carentes, titulares
										da credencial de Passe Livre, conforme a Lei nº
										8.899/1994 e a Portaria Nº 1.579, de 25 de
										novembro de 2022.
									</li>
									<li>
										<strong>Acompanhante:</strong> A gratuidade se
										estende ao acompanhante do beneficiário quando
										indicado na credencial do Passe Livre.
									</li>
								</ul>
							</li>
							<li>
								Procedimentos para Obtenção dos Benefícios
								<p>
									Para solicitar a gratuidade ou os descontos, 
									para vendas exclusivamente dos trechos da Planalto 
									Transportes da operação Interestadual com a 
									classe Convencional, o beneficiário deve enviar 
									os seguintes documentos:
								</p>
								<ol>
									<li>
										<strong>Pessoa Idosa:</strong>
										<ul>
											<li>
												Documento de identidade com foto e CPF.
											</li>
											<li>
												Comprovante de renda, como Carteira de
												Trabalho, contracheque, carnê do INSS,
												extrato de pagamento de benefício ou
												declaração fornecida pelo INSS, ou carteira
												de assistência social.
											</li>
										</ul>
									</li>
									<li>
										<strong>ID Jovem:</strong>
										<ul>
											<li>
												Documento de identidade com foto e CPF.
											</li>
											<li>
												Carteirinha ID Jovem válida (frente e
												verso).
											</li>
										</ul>
									</li>
									<li>
										<strong>Passe Livre:</strong>
										<ul>
											<li>
												Documento de identidade com foto e CPF.
											</li>
											<li>
												Credencial de Passe Livre válida (frente e
												verso).
											</li>
										</ul>
										<ul>
											<strong>Acompanhante:</strong>
											<li>
												Se o Cartão do Passe Livre constar a
												informação de "necessidade de acompanhante",
												será emitida outra passagem com 100% de
												desconto para o acompanhante e o
												beneficiário não poderá embarcar
												desacompanhado;
											</li>
											<li>
												O acompanhante precisa ser informado para o
												recebimento do benefício; ou seja, o
												beneficiário ao solicitar o cadastro de
												passe livre deverá fornecer os dados do
												acompanhante.
											</li>
										</ul>
									</li>
								</ol>
							</li>
						</ul>
						<p>
							De acordo com o Art. 151 da Resolução nº 6.033, de 21 de dezembro de 2023, 
							para se obter bilhete de passagem com desconto ou gratuidade, 
							o beneficiário ou seu representante deverá apresentar, 
							no momento da solicitação, documento de identificação oficial com foto, 
							número do CPF e documento válido de comprovação da condição para obtenção de benefício.
						</p>
						<p>
							Para que a apresentação de documentos ocorra em ambiente digital será necessário 
							a realização de um cadastro prévio no site www.planalto.com.br, 
							exclusivamente pelo beneficiário ou seu representante.
						</p>
						<p>
							Após o cadastro no site da Planalto Transportes, a solicitação de desconto ou 
							gratuidade deverá ser feita pelo beneficiário ou pelo seu representante por meio do 
							WhatsApp (55) 4020-7488. O beneficiário/representante deverá enviar 
							documento de identificação oficial com foto e CPF idêntico 
							ao informado no cadastro do site da Planalto ou do Muviflex, e o comprovante 
							de elegibilidade do benefício. Além disso, é necessário 
							informar os seguintes dados abaixo::
						</p>
						<ul>
							<li>Número do cadastro Muviflex (número informado após a realização de cadastro no site e confirmação de e-mail)</li>
							<li>Nome completo do beneficiário:</li>
							<li>Data de nascimento do beneficiário:</li>
							<li>CPF do Beneficiário:</li>
							<li>Telefone do beneficiário:</li>
							<li>E-mail do beneficiário:</li>
							<li>Tipo de benefício:</li>
							<li>Nome, CPF, Telefone e Data de nascimento do acompanhante (no caso de passe livre, se assim constar na credencial):</li>
							<li>Instrumento de procuração pública e documento de identificação do represente, com poderes gerais ou poderes específicos para solicitação de desconto ou gratuidade de bilhetes de passagens Interestaduais.</li>
						</ul>
						<p>
							Após o envio dos documentos acima, em até 05 (cinco) dias úteis após a confirmação do cadastro e validação da documentação enviada, 
							o beneficiário poderá efetuar normalmente a sua compra. Antes da finalização da transação, será aplicada automaticamente a regra de
							gratuidade ou desconto, conforme o caso, de acordo com a legislação vigente
						</p>
						
						<p>ATENÇÃO:</p>
						<ul>
							<i>Disponibilidade dos Benefícios</i>
							<li>
								<strong>Disponibilidade:</strong> A concessão dos
								benefícios está sujeita à disponibilidade de assentos na
								viagem, sendo assegurada a reserva dessas vagas até 3
								(três) horas de antecedência em relação ao horário de
								partida do ponto inicial da linha que atende ao trecho
								da viagem solicitada (§ 4º, Art. 149, Resolução nº
								6.033/2023).
							</li>
							<li>
								<strong>Prazo para Solicitação:</strong> 
								Para fins de organização e melhor atendimento, recomenda-se que a solicitação 
								dos benefícios seja realizada com antecedência mínima de 5 (cinco) 
								dias em relação à data prevista para a viagem.
							</li>
							<li>
								<strong>
									O beneficiário de gratuidades e descontos previstos em lei não poderá, 
									ainda que em autorizatárias diferentes, fazer reserva em mais de um horário 
									para o mesmo dia e mesmo destino ou para horários e dias cuja realização da viagem 
									se demonstre impraticável e caracterize domínio de reserva de lugares, 
									em detrimento de outros beneficiários.
								</strong>
							</li>
						</ul>
						<p>
							As viações a seguir disponibilizaram links abaixo para 
							obtenção de informações sobre descontos e gratuidades.
						</p>
						<ul>
							<li>
								Auto Viação 1001:{' '}
								<a href="https://vendas.jcaholding.com.br/">
									Benefícios e Gratuidades - Auto Viação 1001
								</a>
							</li>
							<li>
								Viação Catarinense:{' '}
								<a href="https://vendas.jcaholding.com.br/">
									Benefícios e Gratuidades - Viação Catarinense
								</a>
							</li>
							<li>
								Viação Cometa:{' '}
								<a href="https://vendas.jcaholding.com.br/">
									Benefícios e Gratuidades - Viação Cometa
								</a>
							</li>
							<li>
								Expresso do Sul:{' '}
								<a href="https://vendas.jcaholding.com.br/">
									Benefícios e Gratuidades - Expresso do Sul
								</a>
							</li>
							<li>
								Rápido Ribeirão Preto:{' '}
								<a href="https://vendas.jcaholding.com.br/">
									Benefícios e Gratuidades - Rápido Ribeirão Preto
								</a>
							</li>
						</ul>
						<p>
							Os benefícios de desconto ou gratuidade são ofertados em todas as 
							rotas interestaduais e em assentos da classe convencional, 
							respeitando as disponibilidades e regulamentações previstas nas legislações vigente. 
							Para mais informações e detalhes, consulte a{' '}
							<a href="https://www.in.gov.br/en/web/dou/-/resolucao-n-6.033-de-21-de-dezembro-de-2023-533478064">
								Resolução nº 6.033, de 21 de dezembro de 2023
							</a>
							.
						</p>
					</div>
				</StyledRegulation>
			</Container>
		)
	}
}

export { BenefitsPage as ModuleRootComponent }
